export const color = {
    primary: '#1976d2',
}